import { provideZoneChangeDetection } from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter } from "@angular/router";

import { AppComponent } from "./app/app.component";
import { NavigatorService } from "./app/services/engine/navigator.service";
import { AuthInterceptor } from "./app/services/http/auth-interceptor.service";
import { AuthService } from "./app/services/http/auth.service";
import { WebSocketService } from "./app/services/http/web-socket.service";

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter([]),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    WebSocketService,
    NavigatorService,
    AuthService,
    provideAnimations()
  ]
}).catch((err) => console.error(err));
